import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "confirmation", "error"]

  check() {
    const password = this.passwordTarget.value
    const confirmation = this.confirmationTarget.value

    if (confirmation.length > 0 && password !== confirmation) {
      this.errorTarget.classList.remove("hidden")
      this.confirmationTarget.classList.add("border-red-500")
      this.confirmationTarget.classList.remove("border-gray-300", "dark:border-gray-600")
    } else {
      this.errorTarget.classList.add("hidden")
      this.confirmationTarget.classList.remove("border-red-500")
      this.confirmationTarget.classList.add("border-gray-300", "dark:border-gray-600")
    }
  }

  validate(event) {
    const password = this.passwordTarget.value
    const confirmation = this.confirmationTarget.value

    if (password.length > 0 && password !== confirmation) {
      event.preventDefault()
      this.errorTarget.classList.remove("hidden")
      this.confirmationTarget.classList.add("border-red-500")
      this.confirmationTarget.classList.remove("border-gray-300", "dark:border-gray-600")
      this.confirmationTarget.focus()
    }
  }
}
